import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { FeatureSection } from './components/FeatureSection';
import { FooterCTA } from './components/FooterCTA';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-black selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />

        <FeatureSection headline="3 weeks and no change?" subheadline="That can be normal" imageUrl="https://cdn.magicpatterns.com/uploads/hpZzN6FiSVBfgPKLdAS8V3/0x0ss_(34).png" backgroundColor="#FFF176" data-id="element-4" />

        <FeatureSection headline="Your dashboard," subheadline="From day one" imageUrl="https://cdn.magicpatterns.com/uploads/x8YCyVzLXXZqePH1pgTru9/0x0ss_(35).png" backgroundColor="#C8F7DC" data-id="element-5" />

        <FeatureSection headline="See your medication level" subheadline="at a glance" imageUrl="https://cdn.magicpatterns.com/uploads/etsEr9boEJMe2pdg1X6Jt7/0x0ss_(36).png" backgroundColor="#FFDAB9" data-id="element-6" />

        <FeatureSection headline="Know when and where to inject next" imageUrl="https://cdn.magicpatterns.com/uploads/sdKbb26E5A9SvFLkss3ofr/0x0ss_(37).png" backgroundColor="#2A7A7A" textColor="text-white" data-id="element-7" />
      </main>

      <FooterCTA data-id="element-8" />
    </div>;
}